import { styled } from 'next-yak';

import { SkeletonRectangle } from '..';

// *** Components ***
export const Dropdown = styled(SkeletonRectangle)`
  border-end-start-radius: 0;
  border-end-end-radius: 0;
`;
